export default {
  en: {
    PROFILE_FIRST_NAME_TT: 'Enter your first name.',
    PROFILE_FIRST_NAME: 'First name',
    PROFILE_LAST_NAME_TT: 'Enter your last name.',
    PROFILE_LAST_NAME: 'Last name',
    PROFILE_MOBILE_NUMBER_TT: 'Your primary mobile contact number.',
    PROFILE_MOBILE_NUMBER: 'Mobile number',
    PROFILE_PAGE_TITLE: 'Profile',
    PROFILE_SKYPE_HANDLE_TT: 'Ringba account executives are available on Skype. Please update your information in case we need to reach you.',
    PROFILE_SKYPE_HANDLE: 'Skype Handle',
    PROFILE_UPDATE_BUTTON: 'Update',
    PROFILE_UPDATE_SUCCESS: 'Profile updated.',
    PROFILE_UPDATING: 'Updating...',
    PROFILE_LOADING: 'Loading User Profile',
    CHANGE_PASSWORD_TITLE: 'Change Password',
    CHANGE_PASSWORD_BUTTON: 'Change Password',
    CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_LABEL: 'Confirm New Password',
    CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_PH: 'Re-enter new password',
    CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_TT: 'Re-enter your new password',
    CHANGE_PASSWORD_NEW_PASSWORD_LABEL: 'New Password',
    CHANGE_PASSWORD_NEW_PASSWORD_PH: 'New password',
    CHANGE_PASSWORD_NEW_PASSWORD_TT: 'Enter your new password',
    CHANGE_PASSWORD_OLD_PASSWORD_LABEL: 'Current Password',
    CHANGE_PASSWORD_OLD_PASSWORD_PH: 'Current password',
    CHANGE_PASSWORD_OLD_PASSWORD_TT: 'Enter your current password',
    CHANGE_PASSWORD_SUCCESS: 'Password changed successfully',
  }
};